export default __webpack_public_path__ + "static/media/ab-icon.870ac149.webp";